angular.module('bmsApp.settings').factory('LeagueTableSvc', function (CRUDSvc, $window) {

	function compare(params) {
		if(params.format === 'json') {
			return CRUDSvc.get('api/dashboard/league-table/compare', params);
		}else{
			$window.open('api/dashboard/league-table/compare?format=csv', '_blank');
		}
	}

	function performanceData(params) {
		if(params.format === 'json') {
			return CRUDSvc.get('api/dashboard/league-table/performance-data', params);
		}else{
			$window.open('api/dashboard/league-table/performance-data?format=csv', '_blank');
		}

	}

	function performanceGraph(params) {
		return CRUDSvc.get('api/dashboard/league-table/performance-graph', params);
	}

	return {
		compare: compare,
		performanceData: performanceData,
		performanceGraph: performanceGraph,
	};
});



